import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ServiceFollowUpGrid} from "./grid";
import {getServiceFollowUps} from "../../services/service/service_follow_up";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {ServiceFollowUpContext} from "../../context/service_follow_up";
import {PaginateContext} from "../../context/paginate";
import {ServiceFollowUpForm} from "./form";
import {
  appendServiceFilterParams,
  SERVICE_FILTER_DEFAULTS,
  ServiceFilterContainer
} from "../shared/filters/service_filter_container";


export function ServiceFollowUpManagement() {

  const [serviceFollowUps, setServiceFollowUps] = useState([]);
  const [roleId, setRoleId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [filters, setFilters] = useState(SERVICE_FILTER_DEFAULTS);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getServiceFollowUps(paginate);
    if (result.status === 200) {
      const {serviceFollowUpsList, total_count, role_id} = result.data;
      setServiceFollowUps(serviceFollowUpsList || []);
      setGridTotalRowCount(total_count);
      setRoleId(role_id)
    }
  }

  useEffect(() => {
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    appendServiceFilterParams(paginateParams, filters);

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [filters, gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);

  return (
    <ServiceFollowUpContext.Provider value={{
      serviceFollowUps: serviceFollowUps,
      setServiceFollowUps: setServiceFollowUps,
      serviceFollowUp: gridSelectedRow,
      setServiceFollowUp: setGridSelectedRow,
      open: modalOpen,
      setOpen: setModalOpen,
      setLastDataRefresh: setLastDataRefresh,
      roleId: roleId,
    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="flex w-full flex-col gap-4 p-4">

          <ServiceFollowUpForm/>

          <Card className="w-full pt-12">
            <CardHeader floated={true} shadow={false} className="w-full rounded-none">
              <div className="mb-6 flex items-center justify-between gap-8">
                <Typography variant="h5" color="blue-gray">پیگیری سرویس‌ها</Typography>
              </div>
            </CardHeader>

            <CardBody>
              <ServiceFilterContainer onFiltersChange={setFilters}/>
            </CardBody>
          </Card>

          <Card className="w-full">
            <CardBody className="w-full overflow-x-auto p-0">
              <ServiceFollowUpGrid/>
            </CardBody>

            <CardFooterPaginator/>

          </Card>
        </div>
      </PaginateContext.Provider>
    </ServiceFollowUpContext.Provider>
  );
}
